// import React, { useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min';

// const Carousel = () => {
//   useEffect(() => {
//     const bootstrap = require('bootstrap/dist/js/bootstrap.bundle.min');
//     const carouselElement = document.querySelector('#carouselExampleControls');
//     if (carouselElement) {
//       new bootstrap.Carousel(carouselElement, {
//         ride: 'carousel',
//         interval: 3000,  
//       });
//     }
//   }, []);

//   return (
//     <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
//       <div className="carousel-inner">
//         <div className="carousel-item active">
//           <img src="images/slider/1.jpg" className="d-block w-100" alt="Slide 1" />
//         </div>
//         <div className="carousel-item">
//           <img src="/images/slider/6.jpg" className="d-block w-100" alt="Slide 6" />
//         </div>
//         <div className="carousel-item">
//           <img src="images/slider/2.jpg" className="d-block w-100" alt="Slide 2" />
//         </div>
//         <div className="carousel-item">
//           <img src="/images/slider/3.jpg" className="d-block w-100" alt="Slide 3" />
//         </div>
//         <div className="carousel-item">
//           <img src="/images/slider/4.jpg" className="d-block w-100" alt="Slide 4" />
//         </div>
     
        
//       </div>
//       <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
//         <span className="carousel-control-prev-icon" aria-hidden="true"></span>
//         <span className="visually-hidden">Previous</span>
//       </button>
//       <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
//         <span className="carousel-control-next-icon" aria-hidden="true"></span>
//         <span className="visually-hidden">Next</span>
//       </button>
//     </div>
//   );
// };

// export default Carousel;



// import React, { useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

// const Carousel = () => {
//   useEffect(() => {
//     const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.min");
//     const carouselElement = document.querySelector(
//       "#carouselExampleControls"
//     );

//     if (carouselElement) {
//       new bootstrap.Carousel(carouselElement, {
//         ride: "carousel",
//         interval: 4000,
//         pause: false, // IMPORTANT: keeps video running
//       });
//     }
//   }, []);

//   return (
//     <div
//       id="carouselExampleControls"
//       className="carousel slide"
//       data-bs-ride="carousel"
//       data-bs-pause="false"
//     >
//       <div className="carousel-inner">

//         {/* ✅ VIDEO SLIDE (FIRST) */}
//         <div className="carousel-item active">
//           <video
//             className="d-block w-100"
//             src="/images/slider/video.mp4"   
//             autoPlay
//             muted
//             loop
//             playsInline
//           />
//         </div>
//       </div>

//       {/* CONTROLS */}
//       <button
//         className="carousel-control-prev"
//         type="button"
//         data-bs-target="#carouselExampleControls"
//         data-bs-slide="prev"
//       >
//         <span className="carousel-control-prev-icon" />
//       </button>

//       <button
//         className="carousel-control-next"
//         type="button"
//         data-bs-target="#carouselExampleControls"
//         data-bs-slide="next"
//       >
//         <span className="carousel-control-next-icon" />
//       </button>
//     </div>
//   );
// };

// export default Carousel;





// import React from "react";

// const Carousel = () => {
//   return (
//     <section className="hero-video">
//       <video
//         className="hero-video__media"
//         src="/images/slider/video.mp4"
//         autoPlay
//         muted
//         loop
//         playsInline
//       />
//     </section>
//   );
// };

// export default Carousel;


// import React from "react";

// const Carousel = () => {
//   return (
//     <section className="hero-video">
//       {/* VIDEO FOR DESKTOP */}
//       <video
//         className="hero-video__media desktop-only"
//         src="/images/slider/video.mp4"
//         autoPlay
//         muted
//         loop
//         playsInline
//         preload="metadata"
//       />

//       {/* IMAGE FOR MOBILE */}
//       <div className="hero-image mobile-only"></div>
//     </section>
//   );
// };

// export default Carousel;

import React from "react";

const Carousel = () => {
  return (
    <section className="hero-video">
      <video
        className="hero-video__media"
        src="/images/slider/video.mp4"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      />
    </section>
  );
};

export default Carousel;
